import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as showcaseApi from '../../api/showcaseApi';
import * as repActions from '../actions/repActions';
import * as firmActions from '../actions/firmActions';
import * as userActions from '../actions/userActions';
import * as selectors from '../selectors';
import { getUserOrWait, waitFor } from './sagaUtils';

export function* getReps() {
  try {
    yield put(firmActions.getFirmsForLookup());
    const user = yield getUserOrWait();

    yield call(waitFor, state => state.firm.firmsForLookup);
    const firms = yield select(selectors.firms.firmsForUserCompany);
    const isGowUser = yield select(selectors.users.isGowUser);

    const filter = {};
    const query = yield select(selectors.reps.query);

    if (query?.firmId) {
      filter.showcaseFirmId = { eq: query.firmId };
    }

    if (query?.name) {
      //case insensitive graphql query for name
      filter.name = { iLike: `%${query.name}%` };
    }

    if (!isGowUser) {
      filter.showcaseFirmId = { in: firms };
    }

    if (query?.repId) {
      filter.id = { eq: query.repId };
    }

    const page = query?.page ? query?.page : yield select(selectors.reps.activePage);
    const pageSize = 20;
    yield put(userActions.setLoading(true));
    const { reps, count } = yield call(showcaseApi.getReps, {
      filter,
      page,
      pageSize,
      offset: (page - 1) * pageSize,
    });
    yield put(repActions.getRepsSuccess(reps, count));
  } catch (e) {
    yield put(repActions.getRepsFail(e.message));
    toast.error('An error occurred retrieving representatives.');
  } finally {
    yield put(userActions.setLoading(false));
  }
}
export function* getRepsForFirm({ payload: { firmId } }) {
  try {
    const filter = {};
    filter.showcaseFirmId = { eq: firmId };

    yield put(userActions.setLoading(true));
    const { reps, count } = yield call(showcaseApi.getReps, {
      filter,
      page: 0,
      pageSize: 1000,
      offset: 0,
    });
    yield put(repActions.getRepsSuccess(reps, count));
  } catch (e) {
    console.log(e);
    yield put(repActions.getRepsFail(e.message));
    toast.error('An error occurred retrieving representatives.');
  } finally {
    yield put(userActions.setLoading(false));
  }
}

export function* getRepById({ payload: { id } }) {
  try {
    yield put(userActions.setLoading(true));
    const rep = yield call(showcaseApi.getRepById, id);
    yield put(repActions.getRepByIdSuccess(rep));
  } catch (e) {
    yield put(repActions.getRepByIdFail(e.message));
    toast.error('An error occurred retrieving the representative.');
  } finally {
    yield put(userActions.setLoading(false));
  }
}

export function* addRep({ payload: { rep } }) {
  try {
    yield put(userActions.setLoading(true));
    const _rep = yield call(showcaseApi.addRep, rep);
    yield put(repActions.addRepSuccess(_rep));
    yield put(firmActions.getFirmById(rep.showcaseFirmId));
    yield put(repActions.getReps());
    toast.success('Representative created.');
  } catch (e) {
    yield put(repActions.addRepFail(e.message));
    toast.error('An error occurred creating the representative.');
  } finally {
    yield put(userActions.setLoading(false));
  }
}
export function* updateRep({ payload: { rep } }) {
  try {
    yield put(userActions.setLoading(true));
    const _rep = yield call(showcaseApi.updateRep, rep);
    yield put(repActions.updateRepSuccess(_rep));
    yield put(firmActions.getFirmById(rep.showcaseFirmId));
    yield put(repActions.getReps());
    toast.success('Representative updated.');
  } catch (e) {
    yield put(repActions.updateRepFail(e.message));
    toast.error('An error occurred updating the representative.');
  } finally {
    yield put(userActions.setLoading(false));
  }
}
export function* paginate({ payload: { activePage } }) {
  yield put(repActions.getReps());
}

export function* repSagas() {
  yield takeEvery(repActions.getReps, getReps);
  yield takeEvery(repActions.paginate, getReps);
  yield takeEvery(repActions.getRepById, getRepById);
  yield takeEvery(repActions.updateRep, updateRep);
  yield takeEvery(repActions.addRep, addRep);
  yield takeEvery(repActions.getRepsForFirm, getRepsForFirm);
}
